@if (proposal() || request()) {
  <div class="limit-update-actions">
    @if (proposal(); as badge) {
      @if (badge.clickable) {
        <button
          type="button"
          class="limit-update-actions__badge limit-update-actions__badge--button"
          [class.limit-update-actions__badge--review]="badge.needsReview"
          [pTooltip]="badge.tooltip ?? ''"
          tooltipPosition="top"
          [attr.aria-label]="badge.label + ' do ' + bankName()"
          (click)="proposalClick.emit(badge.proposalId)">
          <i class="pi pi-envelope"></i>
          <span>{{ badge.label }}</span>
          <i class="pi pi-arrow-right limit-update-actions__badge-arrow"></i>
        </button>
      } @else {
        <span
          class="limit-update-actions__badge"
          [class.limit-update-actions__badge--review]="badge.needsReview"
          tabindex="0"
          [pTooltip]="badge.tooltip ?? ''"
          tooltipPosition="top">
          <i class="pi pi-envelope"></i>
          <span>{{ badge.label }}</span>
        </span>
      }
    }

    @if (request(); as action) {
      @if (action.kind === 'sent') {
        @if (action.sequentialId !== null) {
          <a
            class="limit-update-actions__sent"
            [routerLink]="rfqsRoute"
            [queryParams]="{ rfq: action.sequentialId }">
            <i class="pi pi-send"></i>
            {{ action.text }}
          </a>
        } @else {
          <span class="limit-update-actions__sent">
            <i class="pi pi-send"></i>
            {{ action.text }}
          </span>
        }
      } @else if (action.kind === 'no-contact') {
        <a class="limit-update-actions__sent" [routerLink]="relationshipsRoute">
          <i class="pi pi-info-circle"></i>
          {{ action.text }} · Marcar contato
        </a>
      } @else {
        <app-button
          [label]="buttonLabel"
          icon="pi pi-send"
          theme="white"
          size="small"
          [noMargin]="true"
          [isLoading]="requesting()"
          loadingText="Enviando..."
          [disabled]="requesting()"
          (sendClick)="requestClick.emit()"></app-button>
      }
    }
  </div>
}
